import type { AiContestEnrollmentDraft } from "../types";

/** 创建空白报名草稿。 */
export function createEmptyEnrollmentDraft(): AiContestEnrollmentDraft {
  return {
    applicantName: "",
    phone: "",
    school: "",
    major: "",
    region: "",
    workName: "",
    workType: "",
    workSize: "",
    remark: "",
  };
}

/** 校验报名草稿必填项，返回首个错误文案。 */
export function validateEnrollmentDraft(draft: AiContestEnrollmentDraft): string | null {
  if (!draft.applicantName.trim()) return "请填写姓名";
  if (!/^1\d{10}$/.test(draft.phone.trim())) return "请输入有效的 11 位手机号";
  if (!draft.school.trim()) return "请填写学校";
  if (!draft.major.trim()) return "请填写专业";
  if (!draft.region.trim()) return "请填写地区";
  if (!draft.workName.trim()) return "请填写作品名称";
  if (!draft.workType) return "请选择作品类型";
  if (!draft.workSize.trim()) return "请填写作品尺寸大小";
  return null;
}
